import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

import { OnboardingBaseModalComponent } from "@common/onboarding-base-modal/onboarding-base-modal.component";

/**
 * Onboarding Figma node 20:7055 ("Onboarding Component - Centred modal"), covering all three of
 * the file's height variants (Tall / Short / X-tall - e.g. H01, S01, B02, P02A, P07, P12A/B/C).
 * The three variants share one structure - eyebrow, heading, one or two body paragraphs, a
 * primary pill button and a secondary text link - and differ only in how much content they carry,
 * so height is left content-driven rather than modelled as three fixed pixel heights: a
 * two-paragraph P12-style card should grow to fit its text the same way a one-paragraph
 * H01-style card does, not clip to a frame sized for one.
 *
 * Renders via the shared OnboardingBaseModalComponent shell (secondaryStyle="link" - a pill
 * button then a plain text link below it, unlike the Anchored prompt's two-pill footer). This is
 * the one genuine modal of the four onboarding cards: open a host component embedding this
 * through `MatDialog.open(..., { panelClass: 'base-modal-panel', backdropClass:
 * 'onboarding-modal-backdrop' })` (see openOnboardingCentredModal) - a transparent backdrop that
 * still blocks the page behind, unlike the dimmed 'base-modal-backdrop' other dialogs use. The
 * backdrop and focus trap come from CDK's dialog container itself, not from this component.
 */
@Component({
  selector: "app-onboarding-centred-modal",
  standalone: true,
  imports: [CommonModule, OnboardingBaseModalComponent],
  templateUrl: "./onboarding-centred-modal.component.html",
  styleUrls: ["./onboarding-centred-modal.component.scss"],
})
export class OnboardingCentredModalComponent {
  @Input() heading = "";
  @Input() bodyPrimary = "";
  @Input() bodySecondary?: string;

  @Input() primaryLabel?: string;
  @Input() secondaryLabel?: string;

  @Output() closed = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
}
